import React, { useRef } from 'react';
import styles from './InputComponents.module.css';
import { formatDate } from '../../../../utils/dateFormatter';
// const DateInput = ({ question, value, error, onChange, isSubmitted, disabled = false, onBlur }) => {
//     const inputRef = useRef(null);

//     // Handle click anywhere on the input to open the date picker
//     const handleClick = (e) => {
//         if (!disabled && inputRef.current) {
//             // Try showPicker first (modern browsers)
//             if (typeof inputRef.current.showPicker === 'function') {
//                 try {
//                     inputRef.current.showPicker();
//                 } catch (err) {
//                     // Fallback: focus the input
//                     inputRef.current.focus();
//                 }
//             } else {
//                 // Fallback for older browsers: focus and click
//                 inputRef.current.focus();
//                 inputRef.current.click();
//             }
//         }
//     };

//     const handleChange = (e) => {
//         onChange(e.target.value);
//         // Note: Reason modal is now handled by handleImmediateFieldChange in DynamicForm
//     };

//     return (
//         <div className={styles.questionWrapper}>
//             <label className={styles.questionLabel}>
//                 {question.text}
//                 {question.required && <span className={styles.required}>*</span>}
//             </label>
//             {question.annotation && (
//                 <span className={styles.annotation}>{question.annotation}</span>
//             )}
//             <div 
//                 onClick={handleClick}
//                 style={{ 
//                     position: 'relative',
//                     cursor: disabled ? 'not-allowed' : 'pointer'
//                 }}
//             >
//                 <input
//                     ref={inputRef}
//                     type="date"
//                     value={value || ''}
//                     onChange={handleChange}
//                     onBlur={onBlur}
//                     disabled={disabled}
//                     className={`${styles.input} ${
//                         error ? styles.inputError : ''
//                     } ${(disabled)
//                         ? styles.disabled
//                         : ''
//                     }`}
//                     style={{
//                         cursor: disabled
//                             ? 'not-allowed'
//                             : 'pointer',
//                         width: '100%'
//                     }}
//                 />

//                 {/* Formatted display */}
//                 {value && (
//                     <div
//                         style={{
//                             marginTop:'4px',
//                             fontSize:'12px',
//                             color:'#555'
//                         }}
//                     >
//                         Selected Date:
//                         {formatDate(value)}
//                     </div>
//                 )}
//             </div>
//             {error && <span className={styles.errorText}>{error}</span>}
//         </div>
//     );
// };

// export default DateInput;



const DateInput = ({
    question,
    value,
    error,
    onChange,
    disabled = false,
    onBlur
}) => {

    const hiddenDateRef = useRef(null);

    const handleOpenPicker = () => {

        if (
            hiddenDateRef.current &&
            !disabled
        ) {

            if (
                typeof hiddenDateRef.current
                .showPicker === 'function'
            ) {

                hiddenDateRef.current
                .showPicker();

            } else {

                hiddenDateRef.current
                .click();
            }
        }
    };

    const handleDateChange = (e) => {

        onChange(e.target.value);
    };

    return (

        <div className={styles.questionWrapper}>

            <label className={styles.questionLabel}>
                {question.text}

                {question.required && (
                    <span
                      className={styles.required}
                    >
                        *
                    </span>
                )}
            </label>

           

            <div style={{position:'relative'}}>

    {/* visible formatted textbox */}

    <input
        type="text"
        value={
            value
            ? formatDate(value)
            : ''
        }
        placeholder="DD-MMM-YYYY"
        readOnly
        onClick={handleOpenPicker}
        className={`${styles.input} ${
            error
            ? styles.inputError
            : ''
        }`}
        style={{
            cursor:'pointer',
            width:'100%'
        }}
    />

    {/* hidden native date control */}

    <input
        ref={hiddenDateRef}
        type="date"
        value={value || ''}
        onChange={handleDateChange}
        onBlur={onBlur}
        disabled={disabled}
        className={styles.input}
        style={{
            position:'absolute',
            top:0,
            left:0,
            width:'100%',
            height:'100%',
            opacity:0,
            cursor:'pointer'
        }}
    />

</div>
            {error && (
                <span
                  className={styles.errorText}
                >
                    {error}
                </span>
            )}

        </div>
    );
};

export default DateInput;